export default {
    init(class_name) {
        let els = document.getElementsByClassName(class_name);
        if(els.length > 0) {
            // let initial_image = els
            this.get_images(els);
        }
    },
    get_images(els) {
        for(let i = 0; i < els.length; i++) {
            let el = els[i];
            el.addEventListener('mouseenter', function( event ) {
                let initial_image = event.target.querySelector('.initial');
                let hover_image = event.target.querySelector('.hover');
                
                if(initial_image && hover_image) {
                    hover_image.classList.remove('hidden');
                    initial_image.classList.add('hidden');
                }
            });

            el.addEventListener('mouseleave', function( event ) {
                let initial_image = event.target.querySelector('.initial');
                let hover_image = event.target.querySelector('.hover');
                
                if(initial_image && hover_image) {
                    hover_image.classList.add('hidden');
                    initial_image.classList.remove('hidden');
                }
            });
        }
    }
}